<!-- 稿件表现 -->
<template>
  <div class="wrap">
    <div class="top">
      <h5>稿件表现</h5>
    </div>
    <p class="text1">UP主近180天的视频（充电专属视频除外），集中在游戏分区, 10min以上的时间区域</p>
    <div class="chartContainer">
      <div class="chart">
        <div class="chartTitle"><span>分区分布</span></div>
        <RingChart v-if="channelDistributionData.data.length" :ringChartInfo="channelDistributionData"
          ref="channelChart"></RingChart>
        <ul class="chartDes">
          <li v-for="(item, index) in channelDistributionData.data" :key="item.name">
            <i :style="[{ background: channelDistributionData.color[index] }]"></i>{{ item.name }}({{ item.value }}%)
          </li>
        </ul>
      </div>
      <div class="chart">
        <div class="chartTitle"><span>时长分布</span></div>
        <RingChart v-if="durationDistributionData.data.length" :ringChartInfo="durationDistributionData"
          ref="durationChart"></RingChart>
        <ul class="chartDes">
          <li v-for="(item, index) in durationDistributionData.data" :key="item.name">
            <i :style="[{ background: durationDistributionData.color[index] }]"></i>{{ item.name }}({{ item.value }}%)
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import RingChart from "@/components/Echart/RingChart.vue";
const colorList = [
  '#f8793e',
  '#f69764',
  '#fab082',
  '#fcc8a4',
  '#fddfc6',
  '#fcf1e7'
]
export default {
  components: {
    RingChart
  },
  props: ["fatherDarenInfo"],
  data() {
    return {
      //分区分布
      channelDistributionData: {
        nodeId: "channelChart", //节点
        data: [], //数据
        color: colorList,
        unit: "%",
        guideline: false, //引导线
      },
      //时长分布
      durationDistributionData: {
        nodeId: "durationChart", //节点
        data: [],
        color: colorList,
        unit: "%",
        guideline: false, //引导线
      },
    }
  },
  methods: {
    initDarenInfo(val) {

      this.channelDistributionData = {
        ...this.channelDistributionData,
        data: val.up_tid_distributions.map(item => {
          return {
            value: item.count,
            name: item.section_desc
          }
        }),
      }
      this.durationDistributionData = {
        ...this.durationDistributionData ,
        data: val.up_duration_distributions.map(item => {
          return {
            value: item.count,
            name: item.section_desc
          }
        })
      }
    },
  },
  created() {
    this.initDarenInfo(this.fatherDarenInfo)
  },
};
</script>
<style lang='scss' scoped>
.chartContainer {
  width: 100%;
  display: flex;
}

.chartContainer .chart {
  flex: 1 1 261px;
  position: relative;
  height: 300px;
  padding: 10px;
  box-sizing: border-box;
}

.chartContainer .chart .chartDes {
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  bottom: 10px;
  padding: 0;
  font-size: 12px;
  color: #8d9099;
}

.chartContainer .chart .chartDes li {
  float: left;
  width: 124px;
  margin-top: 6px;
}

.chartContainer .chart .chartDes li:nth-of-type(2n) {
  margin-right: 0;
}

.chartContainer .chart .chartDes li i {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 6px;
  border-radius: 6px;
}

#channelChart,
#durationChart {
  height: 180px;
}
</style>